import { list_view, lists } from "../../../Config/ApiUrl";
import { formatDateToLocal, numberFormatter } from "../../../Helpers/Helpers";
import DatatableHelperMixin from "../../../Mixins/Global/DatatableHelperMixin";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: 'ListTable',
                url: 'quotation-list',
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: 'Title First',
                        type: 'text',
                        key: 'title_first'
                    },
                    {
                        title: 'Title Last',
                        type: 'text',
                        key: 'title_last'
                    },
                    {
                        title: this.$t('lead_type'),
                        type: 'custom-html',
                        key: 'lead_type',
                        modifier: (value) => {
                            if (value === '1')
                                return `<span class='badge badge-pill badge-success'>People</span>`;
                            return `<span class='badge badge-pill badge-purple'>Organization</span>`;
                        }
                    },

                    {
                        title: this.$t('date'),
                        type: 'custom-html',
                        key: 'date',
                        isVisible: true,
                        modifier: date => formatDateToLocal(date)
                    },

                    {
                        title: this.$t('actions'),
                        type: 'action',
                    },

                ],
                filters: [
                    
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                actionType: 'dropdown',
                orderBy: 'desc',
                actions: [
                    {
                        title: 'Pdf',
                        icon: 'pdf',
                        type: 'page',
                        url: `/quotations`,
                        name: 'pdf',
                        modifier: () => this.$can('create_quotations')
                    },
                    {
                        title: 'Agreement Pdf',
                        icon: 'pdf',
                        type: 'page',
                        url: `/quotations`,
                        name: 'agreement-pdf',
                        modifier: () => this.$can('create_quotations')
                    },
                    {
                        title: this.$t('Copy'),
                        icon: 'copy',
                        type: 'page',
                        url: `/quotations`,
                        name: 'copy',
                        modifier: () => this.$can('create_quotations')
                    },
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'page',
                        url: `quotations`,
                        name: 'edit',
                        modifier: () => this.$can('edit_quotations')
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        url: `quotations`,
                        name: 'delete',
                        modifier: () => this.$can('delete_quotations')
                    }
                ],
            }
        }
    }
}
